import CreditPoolCard from './CreditPoolCard';

export default CreditPoolCard;
